/**
 * Keys that change placement geometry (x, y, width, height, rotation).
 *
 * New shape/text fields are allowed under freeze unless added here (opt-in block list).
 */
export const PLACEMENT_GEOMETRY_KEYS = ['x', 'y', 'width', 'height', 'rotation'] as const

const PLACEMENT_GEOMETRY_KEY_SET = new Set<string>(PLACEMENT_GEOMETRY_KEYS)

export function touchesPlacementGeometry(updates: Record<string, unknown>): boolean {
  return Object.keys(updates).some((key) => PLACEMENT_GEOMETRY_KEY_SET.has(key))
}

/** Pen path `d` string edits (node edit) — blocked under freeze, unlike appearance-only `pathCommands`. */
export function touchesPenPathGeometry(updates: Record<string, unknown>): boolean {
  return Object.prototype.hasOwnProperty.call(updates, 'path')
}

/** True when `updates` only clears a boolean state flag (e.g. self-unlock / self-unfreeze). */
export function isOnlySelfStateClear(
  updates: Record<string, unknown>,
  field: string,
  clearedValue = false
): boolean {
  const keys = Object.keys(updates)

  return keys.length === 1 && keys[0] === field && updates[field] === clearedValue
}
